import React from 'react';
import { Redirect } from 'react-router-dom';
import firebase from '../firebase';
import compose from '../compose';
import UserProvider from './user.provider';
import i18n from 'i18next';
import { withRouter } from 'react-router';

class Auth extends React.Component {
  constructor(props) {
    super(props);

    this.initialState =  {
      shopkeeperId: '',
      language: '',
      userId: '',
      admin: false,
      wait: true,
      shopName: ''
    };
    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    this.unsubscribeAuthStateChanged = this.props.firebase.auth().onAuthStateChanged(this.handleAuthStateChange);
  }

  componentWillUnmount = () => {
    if (this.unsubscribeAuthStateChanged) {
      this.unsubscribeAuthStateChanged();
    }
    if (this.userRef) {
      this.userRef.off('value');
    }
  }

  handleAuthStateChange = (user) => {
    if (user) {
      const userId = this.props.firebase.auth()
        .currentUser.uid;

      this.userRef = this.props.firebase.database().ref(`users/${userId}`);
      this.userRef.on('value', (snapshot) => {
        const shopkeeperId = Object.keys(snapshot.val().shopkeepers)[0];
        this.props.firebase.database().ref(`shopkeepers/${shopkeeperId}/info/name`).once('value', (data) => {
          this.setState({shopName: data.val()});
        });
        if (typeof snapshot.val().language !== 'undefined') {
          const language = snapshot.val().language ;
          i18n.changeLanguage(language);
          this.setState({language});
        }
        if (typeof snapshot.val().admin !== 'undefined') {
          const admin = snapshot.val().admin ;
          this.setState({admin});
        }
        this.setState({shopkeeperId, userId});
      });
    } else {
      this.setState({shopkeeperId: '',
        language: '',
        userId: '',
        admin: false,
        wait: false,
        shopName: ''});
    }
  }
  render() {
    const user = this.state;
    if (user.userId) {
      return (
        <UserProvider user={user}>
          <div>
            {this.props.children}
          </div>
        </UserProvider>
      );
    }
    if (!user.wait) {
      if (this.props.location.pathname !== '/login') {
        return (
          <Redirect to='/login' />
        );
      }
    }
    return (
      null
    );

  }
}

const enhance = compose(firebase, withRouter);

export default enhance(Auth);



// WEBPACK FOOTER //
// ./src/Auth/Auth.js